module.exports = __webpack_public_path__ + "img/horizontal_3_4_3016.051d59b7.png";